module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scoreboard"
  }, [_c('div', {
    staticClass: "scoreboard__wrapper"
  }, [_c('ul', {
    ref: "list",
    staticClass: "scorelist",
    style: ({
      top: _vm.setTopPostion
    })
  }, _vm._l((_vm.scoreData), function(data, index) {
    return _c('li', {
      key: index,
      staticClass: "scorelist__item"
    }, [_c('div', {
      staticClass: "scorelist__score scorelist__score_name"
    }, [_vm._v(_vm._s(data.name))]), _c('div', {
      staticClass: "scorelist__score scorelist__score_total",
      attrs: {
        "title": "Всего"
      }
    }, [_vm._v(_vm._s(data.total))]), _c('div', {
      staticClass: "scorelist__score scorelist__score_hold",
      attrs: {
        "title": "Заблокировано"
      }
    }, [_vm._v(_vm._s(data.hold))]), _c('div', {
      staticClass: "scorelist__score scorelist__score_withdraw",
      attrs: {
        "title": "Списано"
      }
    }, [_vm._v(_vm._s(data.withdraw))]), _c('div', {
      staticClass: "scorelist__score scorelist__score_current",
      attrs: {
        "title": "Доступно"
      }
    }, [_vm._v(_vm._s(data.current))])])
  }), 0)]), (_vm.addControl) ? _c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: ['control__button control__button_up', {
      disable: _vm.disableUpButton
    }],
    on: {
      "click": function($event) {
        return _vm.setScore(0)
      }
    }
  }), _c('button', {
    staticClass: "control__button control__button_down",
    class: ['control__button control__button_up', {
      disable: _vm.disableDownButton
    }],
    on: {
      "click": function($event) {
        return _vm.setScore(1)
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6ac3ee","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/scoreboard/Scoreboard.vue
// module id = 5e1939c26af82ffa09d4
// module chunks = 7